import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { DocumentRequirement, LeaveTypeConfig } from '../interfaces/leave.interface';

export const LeaveTypeService = {
    getByInstitution: async (activeOnly = false): Promise<LeaveTypeConfig[]> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(ENDPOINTS.LEAVE_TYPE.BY_INSTITUTION(institutionId), {
            headers: AuthService.getAuthHeader()
        });
        const data: LeaveTypeConfig[] = response.data;
        return activeOnly ? data.filter(lt => lt.isActive !== false) : data;
    },

    create: async (name: string, documentRequirement: DocumentRequirement = DocumentRequirement.NONE, isPaid: boolean = true): Promise<LeaveTypeConfig> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.post(ENDPOINTS.LEAVE_TYPE.BASE, { institutionId, name, documentRequirement, isPaid }, {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    updateDocumentRequirement: async (id: string, documentRequirement: DocumentRequirement): Promise<LeaveTypeConfig> => {
        const response = await axios.patch(ENDPOINTS.LEAVE_TYPE.UPDATE_DOC_REQUIREMENT(id), { documentRequirement }, {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    updatePaidStatus: async (id: string, isPaid: boolean): Promise<LeaveTypeConfig> => {
        const response = await axios.patch(ENDPOINTS.LEAVE_TYPE.UPDATE_PAID(id), { isPaid }, {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    setActiveStatus: async (id: string, isActive: boolean): Promise<LeaveTypeConfig> => {
        const response = await axios.patch(ENDPOINTS.LEAVE_TYPE.SET_ACTIVE(id), { isActive }, {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    }
};
